/* ============================================================
   icons.jsx — line icon set (stroke, currentColor, 24x24)
   ============================================================ */

const ICON_PATHS = {
  search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.2-3.2" /></>,
  sparkles: <><path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3Z" /><path d="M19 14l.7 1.9L21.5 16.5l-1.8.6L19 19l-.6-1.9-1.9-.6 1.9-.6L19 14Z" /></>,
  wand: <><path d="M15 4V2M15 10V8M19 6h2M9 6h2" /><path d="M17.5 6 6 17.5 4 19l1.5-2L17.5 6Z" /></>,
  heart: <path d="M20.8 5.7c-1.7-1.8-4.4-1.9-6.2-.3L12 7.8 9.4 5.4C7.6 3.8 4.9 3.9 3.2 5.7c-1.8 1.9-1.7 4.9.2 6.7L12 20l8.6-7.6c1.9-1.8 2-4.8.2-6.7Z" />,
  download: <><path d="M12 4v11" /><path d="m7.5 11 4.5 4 4.5-4" /><path d="M5 19h14" /></>,
  share: <><circle cx="6" cy="12" r="2.4" /><circle cx="18" cy="6" r="2.4" /><circle cx="18" cy="18" r="2.4" /><path d="m8.2 10.9 7.6-3.8M8.2 13.1l7.6 3.8" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  image: <><rect x="3.5" y="4.5" width="17" height="15" rx="2.5" /><circle cx="9" cy="10" r="1.6" /><path d="m4.5 17 4.2-4 3.3 3 3-2.6 4 3.6" /></>,
  grid: <><rect x="4" y="4" width="7" height="7" rx="1.4" /><rect x="13" y="4" width="7" height="7" rx="1.4" /><rect x="4" y="13" width="7" height="7" rx="1.4" /><rect x="13" y="13" width="7" height="7" rx="1.4" /></>,
  masonry: <><rect x="4" y="4" width="7" height="9" rx="1.4" /><rect x="13" y="4" width="7" height="6" rx="1.4" /><rect x="4" y="15.5" width="7" height="4.5" rx="1.4" /><rect x="13" y="12" width="7" height="8" rx="1.4" /></>,
  rows: <><rect x="4" y="4.5" width="16" height="6" rx="1.6" /><rect x="4" y="13.5" width="16" height="6" rx="1.6" /></>,
  user: <><circle cx="12" cy="8.5" r="3.5" /><path d="M5.5 19c.8-3.2 3.3-5 6.5-5s5.7 1.8 6.5 5" /></>,
  chevronDown: <path d="m6 9 6 6 6-6" />,
  chevronRight: <path d="m9 6 6 6-6 6" />,
  chevronLeft: <path d="m15 6-6 6 6 6" />,
  arrowRight: <><path d="M4 12h15" /><path d="m13 6 6 6-6 6" /></>,
  arrowUpRight: <><path d="M7 17 17 7" /><path d="M8 7h9v9" /></>,
  x: <path d="M6 6l12 12M18 6 6 18" />,
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1" /></>,
  sliders: <><path d="M4 8h9M17 8h3M4 16h3M11 16h9" /><circle cx="15" cy="8" r="2.2" /><circle cx="9" cy="16" r="2.2" /></>,
  bookmark: <path d="M7 4h10a1 1 0 0 1 1 1v15l-6-3.6L6 20V5a1 1 0 0 1 1-1Z" />,
  copy: <><rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15V6a1 1 0 0 1 1-1h9" /></>,
  more: <><circle cx="6" cy="12" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="18" cy="12" r="1.6" /></>,
  check: <path d="m5 12.5 4.5 4.5L19 7" />,
  lock: <><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></>,
  shuffle: <><path d="M4 7h3l9 10h4M4 17h3l3-3.4M14 7h6M14 17h6" /><path d="m17 4 3 3-3 3M17 14l3 3-3 3" /></>,
  folder: <path d="M4 7a2 2 0 0 1 2-2h3.5l2 2H18a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Z" />,
  clock: <><circle cx="12" cy="12" r="8" /><path d="M12 8v4l3 2" /></>,
  eye: <><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" /><circle cx="12" cy="12" r="3" /></>,
  maximize: <><path d="M8 4H4v4M16 4h4v4M8 20H4v-4M16 20h4v-4" /><path d="M4 4l5 5M20 4l-5 5M4 20l5-5M20 20l-5-5" /></>,
  minimize: <><path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" /><path d="M4 9l5-5M20 9l-5-5M4 15l5 5M20 15l-5 5" /></>,
  trash: <><path d="M5 7h14M10 7V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2M7 7l1 12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1l1-12" /></>,
  bell: <><path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" /><path d="M10 19a2 2 0 0 0 4 0" /></>,
  layers: <><path d="m12 3 8 4.5-8 4.5-8-4.5L12 3Z" /><path d="m4 12 8 4.5L20 12M4 16.5 12 21l8-4.5" /></>,
  zap: <path d="M13 3 5 13h6l-1 8 8-10h-6l1-8Z" />,
  refresh: <><path d="M3.5 12a8.5 8.5 0 0 1 14.5-6M20.5 12a8.5 8.5 0 0 1-14.5 6" /><path d="M18 3v3.5h-3.5M6 21v-3.5h3.5" /></>,
  star: <path d="m12 4 2.3 5 5.4.5-4.1 3.6 1.2 5.3L12 16.7 7.2 18.4l1.2-5.3L4.3 9.5 9.7 9 12 4Z" />,
  globe: <><circle cx="12" cy="12" r="8" /><path d="M3.5 12h17M12 3.8c2.2 2.3 3.3 5.3 3.3 8.2S14.2 17.9 12 20.2c-2.2-2.3-3.3-5.3-3.3-8.2S9.8 6.1 12 3.8Z" /></>,
  edit: <><path d="M5 19h14" /><path d="M14 5.5 18.5 10 9 19.5 4.5 20l.5-4.5L14 5.5Z" /></>,
  compass: <><circle cx="12" cy="12" r="8.5" /><path d="m15.5 8.5-2 5-5 2 2-5 5-2Z" /></>,
  fire: <path d="M12 3c1 3.5-1.5 4.5-1.5 7 0 1.4 1 2 1.5 2 1.5 0 2-1.5 1.7-2.8C16 11 17 13.2 17 15a5 5 0 0 1-10 0c0-3 2.5-4.5 2.5-7C9.5 6 11 4.5 12 3Z" />,
};

function Icon({ name, size = 22, stroke = 1.75, fill = "none", style = {}, className = "" }) {
  const p = ICON_PATHS[name];
  if (!p) return null;
  const filled = name === "heart-fill" || name === "star-fill";
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      fill={fill} stroke="currentColor" strokeWidth={stroke}
      strokeLinecap="round" strokeLinejoin="round"
      style={{ flex: "none", display: "block", ...style }} className={className}
      aria-hidden="true"
    >
      {p}
    </svg>
  );
}

/* solid heart variant for "liked" state */
function HeartSolid({ size = 22, style = {} }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"
      style={{ flex: "none", display: "block", ...style }} aria-hidden="true">
      <path d="M20.8 5.7c-1.7-1.8-4.4-1.9-6.2-.3L12 7.8 9.4 5.4C7.6 3.8 4.9 3.9 3.2 5.7c-1.8 1.9-1.7 4.9.2 6.7L12 20l8.6-7.6c1.9-1.8 2-4.8.2-6.7Z" />
    </svg>
  );
}

Object.assign(window, { Icon, HeartSolid });
